<div class="content-markers" [class.mobile-single-column]="mobileColumns() === 1">
  @for (n of numbersIterate(); track n) {
    <div class="fb-item rounded-3">
      <div class="first-section-wrapper">
        <ngx-skeleton-loader
          class="w-100"
          [theme]="{
            height: '250px',
            'margin-bottom': '10px',
          }"
        />
      </div>
      <div class="second-section-wrapper px-3">
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '80%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '50%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              'border-radius': '0',
              height: '60px',
              'margin-bottom': '10px',
            }"
          />
        </div>

        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              'border-radius': '20px',
              height: '30px',
              margin: '0 auto',
              'margin-bottom': '10px',
            }"
          />
        </div>

        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              'border-radius': '20px',
              height: '30px',
              margin: '0 auto',
              'margin-bottom': '10px',
            }"
          />
        </div>
      </div>
    </div>
  }
</div>
